import { Author, Content } from '@/lib/model';
import { getAuthorLinkWithId } from '@/utils/links/author';
import Image, { ImageProps } from 'next/image';
import { LinkWithChannelLink } from '../../link/LinkWithChannel';
import { cn } from '@/lib/utils';
import { getImageLoaderWidth, imageUrlLoader } from '@/common/media';

type Props = {
  content?: Content;
  containerClassName?: string;
} & Partial<Omit<ImageProps, 'content'>>;

export function PlatformAuthorPicture({
  content,
  containerClassName,
  className,
  ...props
}: Props) {
  const author = content?.author as Author;
  const avatarUrl =
    (typeof author?.profileUrl === 'string'
      ? author.profileUrl
      : author?.profilePicture?.url) ?? '';

  if (author?.id || author?.id_) {
    return (
      avatarUrl && (
        <LinkWithChannelLink
          href={getAuthorLinkWithId(author?.id || author?.id_)}
          className={containerClassName}
        >
          <Image
            src={imageUrlLoader(
              avatarUrl,
              'webp',
              getImageLoaderWidth(props.width as number),
            )}
            alt={avatarUrl}
            className={cn('object-cover aspect-square', className)}
            {...props}
          />
        </LinkWithChannelLink>
      )
    );
  }

  return null;
}
